import { ChangeDetectionStrategy, Component, OnChanges, OnInit, SimpleChanges, inject, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { NumberColumnModel } from '~components/dynamic-table/models/column-types/number-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { UnitsEnum, UnitsEnumHelpers } from '~core/models/enums/units.enum';
import { NumberPipe } from '~core/pipes/number.pipe';
import { TranslationService } from '~core/services/translation.service';
import { NumberInputComponent } from '../../../form/number-input/number-input.component';

@Component({
    selector: 'arc-number-column',
    templateUrl: './number-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [NumberInputComponent, ReactiveFormsModule, NumberPipe]
})
export class NumberColumnComponent<T extends Identifyable<TId>, TId = number>
    extends BaseColumnComponent<T, TId>
    implements OnInit, OnChanges
{
    unitTranslated = signal('');

    private readonly translationService = inject(TranslationService);

    override ngOnInit(): void {
        super.ngOnInit();
        this.getUnit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['item']?.currentValue) {
            this.getUnit();
        }
    }

    get castedColumnModel(): NumberColumnModel {
        return this.columnModel as NumberColumnModel;
    }

    private getUnit(): void {
        if (!!this.castedColumnModel.unit) {
            let unit: string;
            if (typeof this.castedColumnModel.unit === 'string') {
                unit = this.castedColumnModel.unit;
            } else {
                unit = this.castedColumnModel.unit(this.item);
            }

            if (this.castedColumnModel.isUnitTranslated) {
                this.unitTranslated.set(!!unit ? ` ${unit}` : '');
            } else {
                const unitKey = !!UnitsEnum[unit as UnitsEnum] ? UnitsEnumHelpers.getUnitShortTextKey(unit as UnitsEnum) : unit;

                this.translationService.getTextObservable(unitKey).subscribe(result => {
                    this.unitTranslated.set(!!result ? ` ${result}` : '');
                });
            }
        }
    }
}
